import { render, staticRenderFns } from "./EditClientForm.vue?vue&type=template&id=898d70f4&"
import script from "./EditClientForm.vue?vue&type=script&lang=ts&"
export * from "./EditClientForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports